export const actionTypes = {
	LOAD_CONFIG: "loadConfig",
	SAVE_LOGIN: "saveLogin",
	CLEAR_LOGIN: "clearLogin",
	CHECK_TOKEN: "checkToken",
};

export const commitTypes = {
	APP_STATE: "appState",
	SET_ENV: "setEnv",
	SET_CONFIG: "setConfig",
	SET_LOGGEDIN: "setLoggedIn",
	SET_LISTS: "setLists",
	SET_SYNC_ERROR: "setSyncError",
	SAVE_BATCH_NUMBERS: "saveBatchNumbers",
	SAVE_BATCH_FAILURES: "saveBatchFailures",
	SET_USERNAME: "setUsername",
	SET_ROLE: "setRole",
	SET_PARTNER: "setPartner",
	SET_ERROR: "setError",
	TOAST: "showToast",
	SET_ZONE: "setZone",
};
